import { render, staticRenderFns } from "./MainSidebar.vue?vue&type=template&id=a5f4255e&scoped=true&"
import script from "./MainSidebar.vue?vue&type=script&lang=ts&"
export * from "./MainSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./MainSidebar.vue?vue&type=style&index=0&id=a5f4255e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f4255e",
  null
  
)

export default component.exports